import styled from 'styled-components';

export const DialogText = styled.div`
  color: #6a758b !important;
  & b {
    color: #000000 !important;
  }
`;
